import { useEffect, useState } from 'react';

type Return<T> = {
    value: T | undefined;
    dismiss: () => void;
    reset: () => void;
};

type Options<T> = {
    prop: T;
    onDismissed?: () => void;
    onReset?: () => void;
};

const useDismissableProp = <T>(
    { prop, onDismissed, onReset }: Options<T>,
    autoResetDependencies: Array<any> = []
): Return<T> => {
    const [dismissed, setDismissed] = useState(false);
    const reset = () => setDismissed(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(reset, autoResetDependencies);

    return {
        value: dismissed ? undefined : prop,
        dismiss: () => {
            setDismissed(true);
            onDismissed?.();
        },
        reset: () => {
            reset();
            onReset?.();
        },
    };
};

export default useDismissableProp;
